import { render, staticRenderFns } from "./addSplitReturnAmount.vue?vue&type=template&id=1f7b676e&scoped=true&"
import script from "./addSplitReturnAmount.vue?vue&type=script&lang=js&"
export * from "./addSplitReturnAmount.vue?vue&type=script&lang=js&"
import style0 from "./addSplitReturnAmount.vue?vue&type=style&index=0&id=1f7b676e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b676e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7b676e')) {
      api.createRecord('1f7b676e', component.options)
    } else {
      api.reload('1f7b676e', component.options)
    }
    module.hot.accept("./addSplitReturnAmount.vue?vue&type=template&id=1f7b676e&scoped=true&", function () {
      api.rerender('1f7b676e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/components/addSplitReturnAmount.vue"
export default component.exports